import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './HeaderComponent.scss';
import { headerData } from '../../services/CoremediaService';

const HeaderComponent = (props) => {
  const [cmData, setCmData] = useState()
  const location = useLocation()
  let videoPage = false

  if (location.pathname && location.pathname.indexOf('/asset/') > -1) {
    videoPage = true
  }

  useEffect(() => {
    headerData().then((data) => {
      setCmData(data)
    })
  }, [setCmData])


  return(
    <div className={ !videoPage ? 'header-content' : 'header-content nav-only'}>
      <div className="header-content__dimmer">
      <div className="header-content__navi">
        <a href="/"><div className="katsomo-logo"/></a>
        <a className="header-content__liigalink" rel="noreferrer" href="/suomiareena/kaikki">SUOMIAREENA ></a>
        <a className="header-content__liigalink" rel="noreferrer" href="/liiga/kaikki">LIIGA-OSIOON ></a>
        <a className="header-content__liigalink" rel="noreferrer" href="/mestis/kaikki">MESTIS-OSIOON ></a>
      </div>
      { cmData && !videoPage && (
        <div className="header-content__text">
          <h1 className="header-content__text__title">{ cmData.title }</h1>
          <div className="header-content__text__content">{ cmData.text }</div>
        </div>
      )}
      </div>
    </div>
  )
}

export default HeaderComponent
